export default from './RecipeList';


/** WEBPACK FOOTER **
 ** ./app/components/recipeList/index.js
 **/